// The clock voice mode's countdowns read: `performance.now()`, the clock the
// controller sets a pending turn's deadline on and `Utterance.startedAt` uses.
import { useEffect, useState } from 'react';

export const voiceClock = (): number =>
  typeof performance !== 'undefined' ? performance.now() : Date.now();

/** The clock, re-rendering every 200 ms while `active` (a countdown runs). */
export function useVoiceClock(active: boolean): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!active) return;
    const timer = globalThis.setInterval(() => setTick((tick) => tick + 1), 200);
    return () => globalThis.clearInterval(timer);
  }, [active]);
  return voiceClock();
}
